import { provideHttpClient, withFetch, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import { provideRouter, RouteReuseStrategy, withInMemoryScrolling } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { provideApi } from './api/provide-api';
import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { AppRouteReuseStrategy } from './core/app-route-reuse.strategy';
import { authInterceptor } from './core/auth.interceptor';
import { provideMediaPreconnect } from './core/media-preconnect.provider';
import { xsrfSameOriginInterceptor } from './core/xsrf-same-origin.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      // Scroll to top on each forward navigation (e.g. card / "view more" -> listing),
      // restore the saved position on back/forward, and honour in-page #fragments.
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, xsrfSameOriginInterceptor]),
      // CSRF double-submit: Angular reads XSRF-TOKEN cookie and sends X-XSRF-TOKEN header.
      withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' }),
    ),
    // Incremental hydration: below-the-fold @defer (hydrate ...) blocks render in the SSR HTML
    // (so their content stays crawlable) but defer JS hydration until the trigger fires, cutting
    // initial client work. Enables event replay internally.
    provideClientHydration(withIncrementalHydration()),
    { provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy },
    provideApi({ basePath: environment.ecomBffBasePath, withCredentials: true }),
    provideMediaPreconnect(),
    importProvidersFrom(TranslateModule.forRoot()),
  ],
};
